module.exports = __webpack_public_path__ + "static/img/materialsInfo8.0d6b197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo8.png
// module id = rBFo
// module chunks = 2